// extracted by mini-css-extract-plugin
var _1 = "markdown__uMrwe";
export { _1 as "markdown" }
